import { J3PanelBase } from './J3PanelBase';

export class J3ImagePanel extends J3PanelBase {
    // J3ThreeSubからコールされる
    //const imagePanel = new J3ImagePanel(pDebug.level, data.enable, data.show, data.containerID, data.imageID, data.btnContainerID, data.btnID, data.iconOnFile, data.iconOffFile,
    //data.addTitle, data.titleText, data.imageQuery, data.imageFile, data.addLink, data.linkText, data.linkURL, data.target);

    constructor(debugLvl = 0, name = '', enable = true, show = true, visible=true, containerID: string = 'overlay', imageID: string = 'imagepanel', btnContainerID: string = 'header_ul', onOffButtonID: string, iconOnFile: string, iconOffFile: string,
        addTitle = true, titleText = '', imageQuery = '', imageFile = '', addLink = false, linkText='link', linkURL = 'None', target = '_blank') {
        //super('image', 'icn_menu', debugLvl);
        super();
        this.name = name;
        if (enable) {
            const btnContainer = document.querySelector('#' + btnContainerID) as HTMLElement;
            if (btnContainer) {
                /*
                //ボタンDOM構造
                <div class="header_nav">
                    <ul id="header_ul" class="list-inline hover"> //既存要素
                        <li id="icn_map">
                            //ここにオンオフボタンを作成
                        </li>
                    </ul>
                </div>
                */
                const li = document.createElement('li');
                li.setAttribute("id", onOffButtonID);   //li要素にIDを追加
                this.MakeOnOffButtonDOM(li, iconOnFile, iconOffFile);
                btnContainer.appendChild(li);
                this.SetButtons(onOffButtonID);

                if (visible){
                    this.ShowButton(li);
                }else{
                    this.HideButton(li);
                }
            }

            const container = document.querySelector('#' + containerID) as HTMLElement;
            if (container) {
                /*
                //画像パネルDOM構造
                <section id="imagepanel">
                    <div class="popup">
                        <span class="close"><button type="button" id="##"><img src="img/close.png" alt="閉じる"></button></span>
                        <p class="pop_title">Map Title</p>
                        <div class="row box">
                            <div class="col-xxs-12">
                                <img src="" alt="#">
                                <a href="https://xooms.co.jp" target="_blank"> Link Text </a>
                            </div>
                        </div>
                    </div>
                </section>
                */
                //DOM要素を作成
                const section = document.createElement('section');
                section.setAttribute('id', imageID);
                const div = document.createElement('div');
                div.classList.add('popup');
                const span = document.createElement('span');
                span.classList.add('close');
                const button = document.createElement('button');
                button.type = 'button';
                button.setAttribute('id', '##');
                const img = document.createElement('img');
                img.src = 'img/buttons/close.png';
                //タイトル（オプション）
                const p = document.createElement('p');
                p.classList.add('pop_title');
                p.innerHTML = titleText;
                //
                const div2 = document.createElement('div');
                div2.classList.add('row');
                div2.classList.add('box');
                const div21 = document.createElement('div');
                div21.classList.add('col-xxs-12');
                const a = document.createElement('a');
                if (addLink) {
                    a.innerHTML = linkText;
                    a.href = linkURL;
                    a.target = target;
                }
                const img2 = document.createElement('img');
                img2.src = imageFile;

                //DOM構造を最下位から作成
                div21.appendChild(img2);
                if (addLink) {
                    div21.appendChild(a);
                } 
                div2.appendChild(div21);
                //
                button.appendChild(img);
                span.appendChild(button);
                div.appendChild(span);
                //タイトル（オプション）
                if(addTitle){
                    div.appendChild(p);
                }
                div.appendChild(div2);
                //
                section.appendChild(div);
                container.appendChild(section);
                // 表示・非表示の対象を設定
                this.SetOverlay('overlay');
                this.SetOnOffTarget(section, true);

                //タイトルテキスト

            }

            //初期状態
            if (show) {
                this.Show();
            } else {
                this.Hide();
            }
        }
    }
}